import { render, staticRenderFns } from "./SurgDotsMenu.vue?vue&type=template&id=e990350e&scoped=true"
import script from "./SurgDotsMenu.vue?vue&type=script&lang=js"
export * from "./SurgDotsMenu.vue?vue&type=script&lang=js"
import style0 from "./SurgDotsMenu.vue?vue&type=style&index=0&id=e990350e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e990350e",
  null
  
)

export default component.exports